export default function ShareButtons({ pinId, title }) {
  const url = `https://r2z2-78a59.web.app/post?id=${pinId}`;
  return (
    <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
      <button
        onClick={() => {
          navigator.clipboard.writeText(url);
          alert('링크가 복사됐어요!');
        }}
        style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: '1px solid #ddd', background: 'white', fontSize: 12, cursor: 'pointer', minWidth: 70 }}
      >
        🔗 링크 복사
      </button>
      <button
        onClick={() => {
          window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title + ' - r2z2')}&url=${encodeURIComponent(url)}`, '_blank');
        }}
        style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: 'none', background: '#000', color: 'white', fontSize: 12, cursor: 'pointer', minWidth: 70 }}
      >
        𝕏 공유
      </button>
      <button
        onClick={() => {
          window.open(`https://www.threads.net/intent/post?text=${encodeURIComponent(title + ' - r2z2 ' + url)}`, '_blank');
        }}
        style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: 'none', background: '#000', color: 'white', fontSize: 12, cursor: 'pointer', minWidth: 70 }}
      >
        🧵 스레드
      </button>
    </div>
  );
}